module.exports = __webpack_public_path__ + "img/dis_point2.84b34c84.png";